import React, { Component } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import TablePaginationActions from '../../presentational/table-pagination-actions';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import AuthHelper from '../../../libraries/auth-helper';
import CircularProgress from '@material-ui/core/CircularProgress';
import { history } from '../../../shared/configure-store';
import { toast, ToastContainer } from 'react-toastify';
import { withRouter, Link } from 'react-router-dom';
import Api from '../../../libraries/api';
import language from '../../../libraries/label-lang';
import { bindActionCreators } from 'redux';
import { RootActions } from '../../../shared/root-action';
import { connect } from 'react-redux';
import moment from "moment";
import SimpleReactValidator from "simple-react-validator";
import { Selector, SearchInput } from "../styling";
class Reservations extends Component {

    constructor(props) {
        let lang = AuthHelper.getLang();

        super(props);

        this.state = {
            loading: false,
            loadingFilter1: false,
            loadingButton: false,

            errors: [],

            showDialog: false,
            idDelete: '',
            currDelete: '',

            orderBy: '',
            sortedBy: '',
            searchBy: '',
            keyword: '',

            rows: [],
            total: 0,
            perPage: 10,
            currentPage: 1,
            currentPageTable: 0,

            warehouses: [],

            userName: '',
            statusFilter: [],
            statusPast: false,
            classes: [],
            plans: [],

            warehouseList: [],
            warehouseSelected: '',
            iForgotOldReact: null,
            flagSearch: false
        };

        this.validator = new SimpleReactValidator(
            {
                locale: lang
            }
        );
    }

    componentDidMount() {

        document.title = 'Fresh Factory - Tenants';
        let data = AuthHelper.getProfile();

        this._loadData()

        //ini data warehouse gk perlu di perbaharui berkali" ya, jadi taro sini, 
        //padahal udah dibikin component buat warehouse (<WarehouseSelector/>) 
        //biar optimize render yang gk perlu
        Api.get(`/warehouses`).then(resp => {
            this.setState({
                warehouseList: resp.data
            });
        })
            .catch(e => {
                this.showMessage(false, e.message);
                // this.setState({ loading: false, })
            })
    };


    // shouldComponentUpdate(nextProps, nextState) {
    //     if (nextState.sortedBy !== this.state.sortedBy ||
    //         nextState.orderBy !== this.state.orderBy ||
    //         nextState.search !== this.state.search ||
    //         nextState.warehouseId !== this.state.warehouseId ||
    //         nextState.currentPage !== this.state.currentPage
    //     ) {
    //         return true
    //     }

    //     return false
    // }

    _loadData = _ => {
        this.setState({ loading: true, })
        const { sortedBy: sortedBy, orderBy: orderBy, searchBy: searchBy, warehouseSelected: warehouseId, currentPage: page, keyword: keyword } = this.state

        const params = new URLSearchParams({
            ...(sortedBy ? { sortedBy } : {}),
            ...(orderBy ? { orderBy } : {}),
            ...(searchBy ? { searchBy } : {}),
            // ...(search ? { search } : {}),
            ...(warehouseId ? { warehouseId } : {}),
            ...(page ? { page: Number(page) } : {}),
            ...(keyword ? { keyword } : {}),
        }).toString();

        Api.get(`/reservations?${params}`).then(resp => {
            this.setState({
                rows: resp.data,
                perPage: resp.meta.pagination.per_page,
                currentPage: resp.meta.pagination.current_page,
                currentPageTable: resp.meta.pagination.current_page - 1,
                total: resp.meta.pagination.total,
                loading: false,
            });
        })
            .catch(e => {
                this.showMessage(false, e.message);
                this.setState({ loading: false, })
            })



    }



    //past fetch - probably unused
    __fetchData = (update) => {
        this.setState({
            loading: true,
        }
        );

        let page = update ? parseInt(this.state.currentPage + 1) : this.state.currentPage;

        let sort = this.state.orderBy ? '&orderBy=' + this.state.orderBy + '&sortedBy=' + this.state.sortedBy : '';
        let search = this.state.searchBy ? '&search=' + this.state.searchBy : '';

        let route = '/reservations';

        if (search) {
            route = '/reservations?limit=' + this.state.perPage + sort + search;
        } else {
            route = '/reservations?limit=' + this.state.perPage + '&page=' + page + sort + search;
        }

        Api.get(route).then(resp => {
            if (resp.data) {

                this.setState({
                    rows: resp.data,
                    perPage: resp.meta.pagination.per_page,
                    currentPage: resp.meta.pagination.current_page,
                    currentPageTable: resp.meta.pagination.current_page - 1,
                    total: resp.meta.pagination.total,
                    loading: false,
                });

                let wH = [{ id: 'all', name: '----- All -----' }];
                let tmpName = {};
                resp.data.map(i => {
                    if (i.warehouse && i.warehouse.name) {
                        tmpName[i.warehouse.name] = true;
                    }
                });

                //why there's nested call ?😂
                Api.get('/warehouses').then(resp1 => {
                    if (resp1.data) {
                        Object.keys(tmpName).map(y => {
                            if (y) {
                                resp1.data.map(x => {
                                    if (x.name && x.name == y) {
                                        wH.push({
                                            id: x.id,
                                            name: x.name
                                        });
                                    }
                                })
                            }
                        });
                        if (wH.length) {
                            this.setState({
                                warehouseList: wH,
                                loadingFilter1: false,
                                warehouseSelected: 'all'
                            });
                        }

                    }
                }).catch(err => {
                    this.showMessage(false, err.message);
                });
            }
        }).catch(err => {

            this.setState({
                loading: false,
            }
            );
        });
    };

    handleChange(e, prop) {

        this.setState({

            [prop]: e.target.value

        })

    };


    handleOpen = (row) => {
        this.setState({
            showDialog: true,
            idDelete: row.id,
            currDelete: row.name,
        })
    };

    handleClose = () => {
        this.setState({
            showDialog: false,
        })
    };

    handleDelete = () => {

        if (this.state.idDelete) {
            Api.delete('/reservations/' + this.state.idDelete, '', false).then(resp => {

                this.setState({
                    showDialog: false,
                }
                );

                this.showMessage(true, 'Successfully deleted');
                // this.__fetchData(false);
                this._loadData()

            }).catch(err => {

                this.setState({
                    showDialog: false
                }
                );

                this.showMessage(true, 'Successfully deleted');
                // this.__fetchData(false);
                this._loadData()
            });
        }
    };

    handleGo = (link) => {
        history.push(link);
    };

    showMessage = (status, message) => {
        if (status) {
            toast.success(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        } else {
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    };

    // handleSearch = () => {
    //     this.__fetchData(false);
    // };
    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this._loadData()
            // this.__fetchData(false);
        }
    };

    handleSort = (val) => {

        let sortedBy = this.state.sortedBy;

        if (val !== this.state.orderBy) {
            sortedBy = 'asc';
        } else {
            if (sortedBy && sortedBy === 'asc') {
                sortedBy = 'desc';
            } else {
                sortedBy = 'asc';
            }
        }

        this.setState({
            orderBy: val,
            sortedBy: sortedBy,
            loading: true
        }, () => {
            this._loadData()
            // this.__fetchData(false);
        });
    };

    handleChangePage = (event, newPage) => {
        this.setState({
            rows: [],
            currentPage: newPage + 1,
            currentPageTable: newPage + 1,
            loading: true,
        }, () => {
            this._loadData()
            // this.__fetchData(true);
        });
    };

    handleChangeRowsPerPage = event => {
        this.setState({
            perPage: parseInt(event.target.value, 10),
            currentPage: 1,
            loading: true,
        }, () => {
            this._loadData()
            // this.__fetchData(false);
        });
    };

    handleStep1(e, prop) {
        if (prop === 'warehouse') {

            if (e.target.value) {

                // let temp = '';
                //
                // _.forEach(this.state.warehouseList, function(item,index){
                //     if(e.target.value === item.id){
                //         temp = item.id+', '+item.name;
                //     }
                // });
                let page = this.state.currentPage;

                let sort = this.state.orderBy ? '&orderBy=' + this.state.orderBy + '&sortedBy=' + this.state.sortedBy : '';
                let search = '&search=warehouseId:' + e.target.value;

                let route = '/reservations';

                if (search) {
                    route = '/reservations?limit=' + this.state.perPage + sort + search;
                } else {
                    route = '/reservations?limit=' + this.state.perPage + '&page=' + page + sort + search;
                }

                // Api.post('/reservation/times',{warehouseId:e.target.value}).then(resp => {
                // Api.get(route).then(resp => {
                //     if (resp.data) {
                //
                //         this.setState({
                //             rows: resp.data,
                //             perPage: resp.meta.pagination.per_page,
                //             currentPage: resp.meta.pagination.current_page,
                //             currentPageTable: resp.meta.pagination.current_page - 1,
                //             total: resp.meta.pagination.total,
                //             loading: false,
                //         });
                //     }
                // });


                this.setState({

                    [prop]: e.target.value,

                    warehouseSelected: e.target.value,

                    loading: true,

                }, () => {
                    this.__fetchReservationList(e.target.value);
                });

            }

        }

    };

    __fetchReservationList = (id) => {
        let data = { warehouseId: id };
        if (id != 'all') {
            Api.post('/reservation/available', data).then(resp => {
                if (resp.data) {
                    this.setState({
                        rows: resp.data,
                        loading: false
                    });
                }

            }).catch(err => {
                console.log(err);
            });
        }
        else {
            // this.__fetchData(false);
            this._loadData()
        }
    };

    __handleSearchEvent = (data, props) => {
        let lang = {};
        if (this.props.toggle_set_lang === 'indo') {
            lang = language.id;
        } else {
            lang = language.en;
        }
        const text = lang;

        this.setState({
            [props]: data ? data : ''
        }, () => {

            let message = '';
            if (props == 'searchBy' || props == 'keyword') {
                if ((data == 'nota' || data == 'status' || data != '') && this.state.keyword && this.state.searchBy) {
                } else {
                    if ((this.state.searchBy == '' || this.state.searchBy == null) && (this.state.keyword != '' || this.state.keyword != null)) {
                        message = text.label_sortBy;
                    }
                    else if ((this.state.searchBy != '' || this.state.searchBy != null) && (this.state.keyword == '' || this.state.keyword == null)) {
                        this.setState({
                            flagSearch: true
                        })
                        console.log(this.state.flagSearch)

                        if (this.state.flagSearch === true) {
                            message = text.label_browse + ' ' + text.label_reservation;

                        } else {
                            return this.state.flagSearch
                        }
                    }
                    else {
                    }

                }
            }

            if (message) {
                this.showMessage(false, message + ' tidak boleh kosong!');
            } else {

                if (props == 'warehouseSelected') {
                    this.setState({
                        searchBy: '',
                        keyword: ''
                    }, () => {
                        // this.handleChange(this,'keyword');
                        this._loadData();
                    })
                } //'FNC-TE-TGR20200901-42547')
                else {
                    this._loadData();
                }
            }
        });
    };


    render() {
        let lang = {};
        if (this.props.toggle_set_lang === 'indo') {
            lang = language.id;
        } else {
            lang = language.en;
        }
        const text = lang;
        // const warehouse_data = useFetch("/warehouses");

        return (

            <div className='dashboard-detail'>
                <nav aria-label='breadcrumb'>
                    <ol className='breadcrumb'>
                        <li className='breadcrumb-item'><Link to='/' >{text.label_dashboard}</Link></li>
                        <li className='breadcrumb-item active' aria-current='page'>{text.label_reservation}</li>
                    </ol>
                </nav>
                <h2 className='text-uppercase'>{text.label_reservation}
                    <Button
                        variant='contained'
                        color='primary'
                        className='float-right mb-3'
                        onClick={() => this.handleGo('/reservations/add')}
                    >
                        {text.button_add} {text.label_reservation}
                    </Button>
                </h2>

                {/* New Filter, TBContinue */}
                <div className='d-inline-flex align-items-center w-100 justify-content-between my-2'>
                    {/*<WarehouseSelector*/}
                    {/*    vertical*/}
                    {/*    title={text.label_warehouses}*/}
                    {/*    onChange={x => this.setState({ warehouseSelected: x }, _ => {*/}
                    {/*        this._loadData()*/}
                    {/*    })}*/}
                    {/*/>*/}
                    <Selector
                        vertical
                        className="w-100"
                        title={text.label_warehouses}
                        //   selected={(x) => setState({ ...state, warehouse_id: x })}
                        // selected={onChange}
                        // selected={x => this.setState({ warehouseSelected: x }, _ => {
                        //     this._loadData()
                        // })}
                        selected={(x) => this.__handleSearchEvent(x, 'warehouseSelected')}
                        // item={warehouse_data.data}
                        item={this.state.warehouseList}
                    />

                    <div className='d-inline-flex align-items-center justify-content-between'>
                        <Selector
                            vertical
                            className="w-100 mr-2"
                            title={text.label_sortBy}
                            value={this.state.searchBy}
                            selected={(x) => this.__handleSearchEvent(x, 'searchBy')}
                            onChange={(x) => this.__handleSearchEvent(x, 'searchBy')}
                            item={[
                                {
                                    name: 'Surat Jalan',
                                    id: 'nota'
                                },
                                {
                                    name: 'Status',
                                    id: 'status'
                                },
                            ]}
                        />
                        <SearchInput
                            placeholder={text.label_browse + ' ' + text.label_reservation}
                            value={this.state.keyword}
                            onSubmit={(x) => this.__handleSearchEvent(x, 'keyword')}
                            onKeyPress={(x) => this.__handleSearchEvent(x, 'keyword')}
                            onKeyUp={(x) => this.__handleSearchEvent(x, 'keyword')}
                            onChange={(x) => this.__handleSearchEvent(x, 'keyword')}
                            name="keyword"
                            type="text"
                        />
                    </div>
                </div>

                <div className='clearfix'> </div>
                <div className='table-wrapper'>
                    <Table className='table-list' size='small' >
                        <TableHead>
                            <TableRow>
                                <TableCell className='clickable' onClick={() => this.handleSort('nota')} >{text.label_reservation_code}
                                    {this.state.orderBy === 'nota' && (
                                        <span className='icon-sort'>{
                                            this.state.sortedBy === 'asc' ? (
                                                <i className='fas fa-sort-up'> </i>
                                            ) : (
                                                    <i className='fas fa-sort-down'> </i>
                                                )
                                        }</span>
                                    )}
                                </TableCell>
                                <TableCell className='clickable' onClick={() => this.handleSort('warehouses:warehouse_id|warehouses.name')} >{text.label_warehouses}
                                    {this.state.orderBy === 'warehouses:warehouse_id|warehouses.name' && (
                                        <span className='icon-sort'>{
                                            this.state.sortedBy === 'asc' ? (
                                                <i className='fas fa-sort-up'> </i>
                                            ) : (
                                                    <i className='fas fa-sort-down'> </i>
                                                )
                                        }</span>
                                    )}
                                </TableCell>
                                {/*<TableCell className='clickable' onClick={() => this.handleSort('tenant|company_name')} >{text.label_tenants}*/}
                                {/*    {this.state.orderBy === 'tenant|company_name' && (*/}
                                {/*        <span className='icon-sort'>{*/}
                                {/*            this.state.sortedBy === 'asc' ? (*/}
                                {/*                <i className='fas fa-sort-up'> </i>*/}
                                {/*            ) : (*/}
                                {/*                <i className='fas fa-sort-down'> </i>*/}
                                {/*            )*/}
                                {/*        }</span>*/}
                                {/*    )}*/}
                                {/*</TableCell>*/}
                                {/*<TableCell className='clickable' onClick={() => this.handleSort('tenant|contact_phone_cell')}>{text.label_contact} {text.label_tenants}*/}
                                {/*    {this.state.orderBy === 'tenant|contact_phone_cell' && (*/}
                                {/*        <span className='icon-sort'>{*/}
                                {/*            this.state.sortedBy === 'asc' ? (*/}
                                {/*                <i className='fas fa-sort-up'> </i>*/}
                                {/*            ) : (*/}
                                {/*                <i className='fas fa-sort-down'> </i>*/}
                                {/*            )*/}
                                {/*        }</span>*/}
                                {/*    )}*/}
                                {/*</TableCell>*/}
                                <TableCell className='clickable' onClick={() => this.handleSort('reservationDate')}>{text.label_reservation_date}
                                    {this.state.orderBy === 'reservationDate' && (
                                        <span className='icon-sort'>{
                                            this.state.sortedBy === 'asc' ? (
                                                <i className='fas fa-sort-up'> </i>
                                            ) : (
                                                    <i className='fas fa-sort-down'> </i>
                                                )
                                        }</span>
                                    )}
                                </TableCell>
                                {/* <TableCell className='clickable' onClick={() => this.handleSort('date_received')}>{text.label_warehouses_date}
                                    {this.state.orderBy === 'date_received' && (
                                        <span className='icon-sort'>{
                                            this.state.sortedBy === 'asc' ? (
                                                <i className='fas fa-sort-up'> </i>
                                            ) : (
                                                <i className='fas fa-sort-down'> </i>
                                            )
                                        }</span>
                                    )}
                                </TableCell>*/}
                                <TableCell className='clickable' onClick={() => this.handleSort('SKUTotal')}>Jenis Produk (SKU)
                                    {this.state.orderBy === 'SKUTotal' && (
                                        <span className='icon-sort'>{
                                            this.state.sortedBy === 'asc' ? (
                                                <i className='fas fa-sort-up'> </i>
                                            ) : (
                                                    <i className='fas fa-sort-down'> </i>
                                                )
                                        }</span>
                                    )}
                                </TableCell>
                                <TableCell className='clickable' onClick={() => this.handleSort('productsTotal')}>{text.label_quantity} {text.label_products} (IKU)
                                    {this.state.orderBy === 'productsTotal' && (
                                        <span className='icon-sort'>{
                                            this.state.sortedBy === 'asc' ? (
                                                <i className='fas fa-sort-up'> </i>
                                            ) : (
                                                    <i className='fas fa-sort-down'> </i>
                                                )
                                        }</span>
                                    )}
                                </TableCell>
                                <TableCell className='clickable' onClick={() => this.handleSort('status')}>{text.label_status}
                                    {this.state.orderBy === 'status' && (
                                        <span className='icon-sort'>{
                                            this.state.sortedBy === 'asc' ? (
                                                <i className='fas fa-sort-up'> </i>
                                            ) : (
                                                    <i className='fas fa-sort-down'> </i>
                                                )
                                        }</span>
                                    )}
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.loading ? (
                                <TableRow>
                                    <TableCell colSpan={6} align='center' className='py-5'>
                                        <CircularProgress color='primary' />
                                    </TableCell>
                                </TableRow>
                            ) : (
                                    this.state.rows.length === 0 ? (
                                        <TableRow style={{ height: 33 * this.state.perPage }}>
                                            <TableCell colSpan={6} style={{ textAlign: 'center' }}>{text.label_no}</TableCell>
                                        </TableRow>
                                    ) : (
                                            this.state.rows.map((row, i) => (
                                                <TableRow
                                                    key={i}
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={_ => {
                                                        history.push({
                                                            pathname: 'reservations/detail/' + row.id,
                                                            state: row
                                                        })
                                                    }}
                                                    key={row.id}
                                                    selected={row.selected}>
                                                    <TableCell>{row.nota ? row.nota : '-'}</TableCell>
                                                    <TableCell>{row.warehouse && row.warehouse.name ? row.warehouse.name : '-'}</TableCell>
                                                    {/*<TableCell>{row.tenant && row.tenant.company_name ? row.tenant.company_name : '-'}</TableCell>*/}
                                                    {/*<TableCell>{row.tenant && row.tenant.contact_phone_cell ? row.tenant.contact_phone_cell : '-'}</TableCell>*/}
                                                    {/*<TableCell>{row.reservationDate && row.reservationDate ? moment(row.reservationDate).format('DD MMM YYYY') : '-'}</TableCell>*/}
                                                    <TableCell>{row.reservationDate ? moment(row.reservationDate).format('DD MMM YYYY') : '-'}</TableCell>
                                                    <TableCell>{row.SKUTotal ? row.SKUTotal : 0}</TableCell>
                                                    <TableCell>{row.productsTotal ? row.productsTotal : 0}</TableCell>
                                                    <TableCell>{row.status ? coverName(row.status, this.props.toggle_set_lang === 'indo') : '-'}</TableCell>
                                                    <TableCell></TableCell>
                                                </TableRow>
                                            ))
                                        )
                                )}

                        </TableBody>
                    </Table>
                </div>

                <TablePagination
                    rowsPerPageOptions={[10, 25, 50]}
                    component='div'
                    className='responsive'
                    count={this.state.total}
                    rowsPerPage={this.state.perPage}
                    page={this.state.currentPageTable}
                    backIconButtonProps={{
                        'aria-label': 'previous page',
                    }}
                    nextIconButtonProps={{
                        'aria-label': 'next page',
                    }}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                />

                <Dialog
                    maxWidth='sm'
                    fullWidth={true}
                    open={this.state.showDialog}
                    onClose={this.handleClose}
                    aria-labelledby='form-dialog-title'>
                    <DialogTitle id='form-dialog-title'>DELETE PROJECT: {this.state.currDelete}</DialogTitle>
                    <DialogContent>
                        <p>{text.text_delete}</p>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant='contained'
                            className='mr-3'
                            onClick={this.handleClose}
                        >
                            {text.button_cancel}
                        </Button>
                        <Button
                            variant='contained'
                            color='primary'
                            className=''
                            onClick={this.handleDelete}
                            disabled={this.state.loadingButton && 'disabled'}
                        >
                            {text.button_delete}{this.state.loadingButton && <i className='fa fa-spinner fa-spin'> </i>}
                        </Button>
                    </DialogActions>
                </Dialog>

                <ToastContainer />
            </div>

        )

    }
}

const mapStateToProps = (state) => {

    return {

        toggle_set_lang: state.toggle_set_lang,

    };

};

const mapDispatchToProps = (dispatch) => {

    return bindActionCreators(RootActions, dispatch)

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Reservations));


export const coverName = (status, bahasa) => {
    if (!bahasa) return status

    switch (status.toLowerCase()) {
        case 'next': return 'Akan Datang'
        case 'received': return 'Sudah Sampai'
        case 'proceed': return 'Diproses'
        case 'finish': return 'Diterima'
        case 'canceled': return 'Batal'
        case 'shuttle request': return 'Shuttle Diminta'
        case 'shuttle requested': return 'Shuttle Diminta'
        case 'shuttle receive': return 'Shuttle Diterima'
        case 'shuttle received': return 'Shuttle Diterima'
        case 'shuttle cancel': return 'Shuttle Batal'
        case 'shuttle canceled': return 'Shuttle Batal'
        default: return status
    }
}